import { Component, ElementRef, forwardRef, Input, output } from '@angular/core';
import { DpDatePickerModule, ECalendarValue, IDayCalendarConfig } from 'ng2-date-picker';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { dateToPLString } from '../../services/helpers';
import { dateFormat } from '../forms/custom.validators';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-date-picker',
  standalone: true,
  imports: [
    DpDatePickerModule,
    CommonModule,
    FormsModule,
    NgxMaskDirective
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true
    }
  ],
  templateUrl: './date-picker.component.html'
})
export class DatePickerComponent implements ControlValueAccessor {

  @Input()
  public id: string = '';

  @Input()
  public mode: 'day' | 'month' = 'day';

  public change = output<any>();

  public value: any = null;

  public calendarConfig: IDayCalendarConfig = {
    firstDayOfWeek: 'mo',
    format: 'DD.MM.YYYY',
    returnedValueType: ECalendarValue.String
  };

  public onChange: any = () => {
  };

  public onTouch: any = () => {
  };

  public disabled = false;

  constructor(private elRef: ElementRef) {
  }

  public isInvalid(): boolean {
    const list: DOMTokenList = this.elRef.nativeElement.classList;
    return list.contains('ng-invalid')
      && (list.contains('ng-touched'));
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(v: any): void {
    if (v) {
      const d = new Date(v);
      this.value = dateToPLString(d);
    } else {
      this.value = v;
    }
  }

  public onFocusOut(): void {
    const list: DOMTokenList = this.elRef.nativeElement.classList;
    list.add('ng-touched');
  }

  public onPickDate(v: string): void {
    if (new RegExp(dateFormat).test(v)) {
      const d = new Date(v);
      d.setUTCFullYear(+`${v[6] + v[7] + v[8] + v[9]}`, (+`${v[3] + v[4]}`) - 1, +`${v[0] + v[1]}`);
      d.setUTCHours(0, 0, 0, 0);
      this.change.emit(d);
      this.onChange(d);
    } else {
      this.change.emit(v);
      this.onChange(v);
    }
  }
}
